var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.75c-2.49 0-3.75-1.41-3.75-4.2V5.68c0-1.02.12-2.48 1.18-3.28.89-.66 2.17-.71 4.06-.16 2.48.72 4.55 2.79 5.27 5.27.55 1.88.5 3.17-.16 4.05-.8 1.07-2.26 1.19-3.28 1.19H15zM13.34 3.6c-.39.29-.58.97-.58 2.08v2.88c0 2.24.86 2.7 2.25 2.7h3.32c1.1 0 1.78-.19 2.08-.58.35-.46.32-1.38-.07-2.73-.58-1.97-2.28-3.68-4.25-4.25-.74-.23-1.34-.34-1.81-.34-.41 0-.73.08-.94.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46 22.62c-4.09-.66-7.42-3.98-8.08-8.07C.53 9.29 3.92 4.33 9.11 3.27c.41-.08.8.18.89.58.08.41-.18.8-.58.89-4.39.9-7.27 5.1-6.54 9.57.56 3.46 3.37 6.27 6.83 6.83 4.49.72 8.68-2.17 9.57-6.58a.75.75 0 1 1 1.47.29 9.852 9.852 0 0 1-9.68 7.9c-.53 0-1.07-.04-1.61-.13z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGraph);
export default __webpack_public_path__ + "static/media/vuesax-outline-graph.907518549333809998a1a01014b1aef5.svg";
export { ForwardRef as ReactComponent };